export default __webpack_public_path__ + "static/media/profile.891e7680.jpeg";